import { api } from "@/api";

class API {
  static getOfficeList(payload) {
    return api.get(`/v1/escritorios/`, { params: payload });
  }

  static getOffice(id) {
    return api.get(`/v1/escritorios/${id}/`);
  }

  static postOffice(payload) {
    return api.post(`/v1/escritorios/`, payload);
  }

  static putOffice({ id, payload }) {
    return api.put(`/v1/escritorios/${id}`, payload);
  }

  static getListPolicy(payload) {
    return api.get(`/v1/garantia/apolices`, { params: payload });
  }

  static getListQuotation(payload) {
    return api.get(`/v1/garantia/cotacoes`, { params: payload });
  }

  static getListQuotationAgro(payload) {
    return api.get(`/v1/agro/cotacoes`, { params: payload });
  }
}

export default API;
